<template lang="">
    <div class="body"> 
        <div class="adverimg">
            <img src="../assets/ad7.png" alt="">
        </div>
        <div class="ad_detail">
            <div class = "infoapply">
                <div class="info-title">
                    <img src="../assets/ad8.png" alt="">
                    <span>申请人信息</span>
                    <img src="../assets/ad9.png" alt="">
                </div>
                <div class = "infodetail">
                    <ul class="ad_contain">
                        <li class="ad_contain_title">
                            姓名
                            </li>
                        <li class="ad_contain_detail">{{crContactName}}</li>
                    </ul>
                    <ul class="ad_contain">
                        <li class="ad_contain_title">电话</li>
                        <li class="ad_contain_detail">
                            <a :href="'tel:'+ crContactTel">
                                {{crContactTel}}
			                </a>
                            
                           </li>
                    </ul>
                </div>
            </div>
            <div class = "link">
                <img src="../assets/ad10.png" alt="">
                <img src="../assets/ad10.png" alt="">
            </div>
            <div class = "infoapply">
                <div class="info-title">
                    <img src="../assets/ad8.png" alt="">
                    <span>医院信息</span>
                    <img src="../assets/ad9.png" alt="">
                </div>
                <div class = "infodetail">
                    <ul class="ad_contain">
                        <li class="ad_contain_title">医院名称</li>
                        <li class="ad_contain_detail">{{crName}}</li>
                    </ul>
                    <ul class="ad_contain">
                        <li class="ad_contain_title">医院等级</li>
                        <li class="ad_contain_detail">{{crClassName}}</li>
                    </ul>
                    <ul class="ad_contain">
                        <li class="ad_contain_title">出院量</li>
                        <li class="ad_contain_detail">{{crDischargeQuantity}}人/年</li>
                    </ul>
                    <ul class="ad_contain">
                        <li class="ad_contain_title">所在地区</li>
                        <li class="ad_contain_detail">{{location}}</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
  .body{
    height: 100%;
    background: #4E90FF;
  }
    .adverimg img {
        width: 100%;
        margin: -5px 0;
    }
    .link{
        margin-top: -30px;
        display: flex;
        justify-content: space-between;
        margin:-26px 50px;
    }
    .link img{
        width: 12px;
        height: 49px;

    }
    .ad_detail{
        width: 100%;
        padding-bottom: 30px;
    }
    .infoapply{
        width: 80%;
        margin:10px auto;
        background: white;
        border-radius: 15px;
        padding: 16px;
    }
    .info-title{
        text-align: center;
        color: #424656;
        font-size: 22px;
        font-weight: 500;
    }
    .info-title img{
        width: 35px;
        height: 16px;
        margin:0 10px;
        
    }
    .ad_contain{
        display: flex;
        margin:20px 0px;
        font-size: 18px;
    }
    .ad_contain_title{
        flex:4;
        text-align: right;
        color: #999;
        /* font-weight:300; */
    }
    .ad_contain_detail{
        padding-left: 20px;
        flex:8;
        text-align: left;
        color: #333;  
    }
    .ad_contain_detail a{
        
        color: #10B4B5;  
    }
</style>
<script>
export default{
    name:'',
    data(){
        return {
            meg:'this id',
            cmsOrderId:'',
            crName:'',
            crClassCode:'',
            crDischargeQuantity:'',
            crContactName:'',
            crContactTel:'',
            crProvice:'',
            crCity:'',
            crArea:'',
            location:'',
            crClassName:''
        }
    },
    created () {
        window.scrollTo({
        top: 0,
        // behavior: "smooth"
      });
        console.log('进入了申请详情页')
        this.cmsOrderId = this.$route.params.cmsOrderId;
        console.log(this.cmsOrderId + "999999")
        let channel = localStorage.getItem("channel");
        let promoter = localStorage.getItem("promoter");
        let wxId = localStorage.getItem("wxId");
        let params = {
        cmsOrderId: this.cmsOrderId,
        channel:channel,
        promoter:promoter,
        wxId:wxId
            };
        this.getrequestAd(params)  
        console.log(this.crName)
    },
    methods: {
      getrequestAd(params) {
      this.$server.getrequestAd(params).then(res => {
        if (res.result == 1) {
            console.log('申请后的接口调用成功')
            console.log(res.customerInfo)
            this.crName = res.customerInfo.crName
            this.crClassCode = res.customerInfo.crClassCode
            this.crDischargeQuantity = res.customerInfo.crDischargeQuantity
            this.crContactName = res.customerInfo.crContactName
            this.crContactTel = res.customerInfo.crContactTel
            this.crProvice = res.customerInfo.crProvice
            this.crCity = res.customerInfo.crCity
            this.crArea = res.customerInfo.crArea
            this.crClassName = res.customerInfo.crClassName
            this.location = this.crProvice+this.crCity+this.crArea
          }
      }
    )}
    },
    
}
</script>

